import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NgbModalConfig, NgbModal } from '@ng-bootstrap/ng-bootstrap';
@Component({
  selector: 'app-confirmation-msg',
  templateUrl: './confirmation-msg.component.html',
  styleUrls: ['./confirmation-msg.component.css'],
  providers: [NgbModalConfig, NgbModal],
})
export class ConfirmationMsgComponent implements OnInit {


  @Output() accepted = new EventEmitter<string>();
  @Output() rejected = new EventEmitter<string>();
  @Input() headerMessage!:string;
  @Input() bodyMessage!:string;
  @Input() isLoading!:boolean;
  @Input() centerOfScreen:boolean = false;
  @Input() acceptLabel = 'Yes, Confirm';
  @Input() rejectLabel = 'Cancel';
  // @Input() showConfirmMessage!:boolean;
  @ViewChild('content') content:any;
  constructor(private config: NgbModalConfig, private modalService: NgbModal) {
    // customize default values of modals used by this component tree
		config.backdrop = 'static';
		config.keyboard = false;
  }

  ngOnInit() {
    if(this.centerOfScreen){
      this.config.centered = true
    }
  }
  

  accept() {
    this.accepted.emit('accepted');
  }

  cancel(){
    this.rejected.emit('rejected');
  }

  open(){
    this.modalService.open(this.content, { windowClass: 'confirmation' });
  }

  close(){
    this.modalService.dismissAll(this.content);
  }

}
